module.exports = __webpack_public_path__ + "img/EM2024@2x.67a54292.png";